//import Libraries
import React from 'react';
import Parser from 'html-react-parser';
//import Components

//import Style classes
import './CardModal.css';

import Icons from '../../../../../assets/icons/icons';

// const CloseButton = (props)=>{
//     return <div className="CloseButton" style={props.style} onClick={props.closeCardModal}>
//                 {Icons.close}
//             </div>
// }

const cardModal = (props) => {
    return (
        <div className="BlogModalWrapper">
            <div className="CloseButton" style={props.style} onClick={props.closeCardModal}>
                {Icons.close}
            </div>
            <h4>제목: {props.title}</h4>
            <hr style={{margin: 0}}/>
            <div>
                { Parser(props.text)}
            </div>
        </div>
    )
}

export default cardModal;



// WEBPACK FOOTER //
// ./src/components/DepartmentModule/Contents/ContentCard/HiddenContent/CardModal.js